/* eslint-disable max-len */
import React from 'react';

import Icon from 'editor/src/component/Icon/index';

interface Props {
  className?: string;
}

/** An open book with text lines. */
function IconTextLibrary({ className }: Props) {
  return (
    <Icon className={className}>
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20 12.5C17.5 10.5 14 9.5 8.5 9.5C7.95 9.5 7.5 9.95 7.5 10.5V28C7.5 28.55 7.95 29 8.5 29C14 29 17.5 30 20 32C22.5 30 26 29 31.5 29C32.05 29 32.5 28.55 32.5 28V10.5C32.5 9.95 32.05 9.5 31.5 9.5C26 9.5 22.5 10.5 20 12.5Z"
          stroke="#212121"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path d="M20 12.5V31.5" stroke="#212121" strokeWidth="2" />
        <path
          d="M11 15H16.5M11 19H16.5M11 23H16.5M23.5 15H29M23.5 19H29M23.5 23H29"
          stroke="#212121"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    </Icon>
  );
}

export default IconTextLibrary;
